// src/theme/components/tabStyles.js
const tabStyles = (theme) => ({
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 48, // Minimum height for better touch targets
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 48, // Better touch target
          [theme.breakpoints.down("sm")]: {
            minWidth: 0, // Allow tabs to be narrower on mobile
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
          },
        },
      },
  },
});

export default tabStyles;
